// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__rEf8m","wrapper-nopadding":"wrapper-nopadding__2XtI2","loading":"loading__2ZFO-","error":"error__2267d","table-loading":"table-loading__o6pYZ","empty-val":"empty-val__18w-z","panelheader-tools":"panelheader-tools__18GSe","propsPanels":"propsPanels___eEgB","new":"new__2svwk","marginLm":"marginLm__GJQVd","marginRm":"marginRm__115rN","fullWidth":"fullWidth__1ug7-","fullHeight":"fullHeight__2oYLu","noData":"noData__6Gc6J","dataTable":"dataTable__1W3cZ"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/DeviceDetail/coms/DeviceBriefData/styles.scss
// module id = 2235
// module chunks = 1